export default __webpack_public_path__ + "static/media/send-message.a291366a.png";